import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { IoHomeOutline } from "react-icons/io5";
import { MdHeadphonesBattery, MdMobileFriendly } from "react-icons/md";
import { FaBlogger, FaMobile } from "react-icons/fa";
import { AiFillMobile } from "react-icons/ai";
import { BiMobileAlt } from "react-icons/bi";
import { TbDeviceAirpods } from "react-icons/tb";
import { MdOutlinePostAdd } from "react-icons/md";

import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

const BottomTabNavigator = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Row className="bottomTab d-lg-none">
      {window.location.pathname === "/" ? (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#0c2f53" }}
        >
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/"
          >
            <IoHomeOutline
              size={"40%"}
              color={"#FFF"}
              style={{ alignSelf: "center" }}
            />
            <p
              className="text-center poppins-semiBold"
              style={{ fontSize: "12px", color: "#FFF" }}
            >
              HOME
            </p>
          </Link>
        </Col>
      ) : (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center bg-white"
        >
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/"
          >
            <IoHomeOutline
              size={"30%"}
              className="txt-green"
              style={{ alignSelf: "center" }}
            />
            <p
              className="txt-green text-center poppins-semiBold"
              style={{ fontSize: "10px" }}
            >
              HOME
            </p>
          </Link>
        </Col>
      )}

      {window.location.pathname === "/mobiles" ? (
        <Col xs={3} style={{backgroundColor:"#0c2f53"}}>
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/mobiles"
          >
            <BiMobileAlt
              size={"30%"}
              className="text-white"
              style={{ alignSelf: "center", marginTop: 4 }}
            />

            <p
              className="text-white text-center poppins-semiBold"
              style={{ fontSize: "12px", color: "#0c2f53" }}
            >
              MOBILE
            </p>
          </Link>
        </Col>
      ) : (
        <Col xs={3} className="bg-white">
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/mobiles"
          >
            <BiMobileAlt
              size={"20%"}
              className="txt-green"
              style={{ alignSelf: "center", marginTop: 12 }}
            />

            <p
              className="txt-green text-center poppins-semiBold"
              style={{ fontSize: "10px" }}
            >
              MOBILE
            </p>
          </Link>
        </Col>
      )}

      {window.location.pathname === "/accessories" ? (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#0c2f53" }}
        >
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/accessories"
          >
            <TbDeviceAirpods
              size={"40%"}
              className="text-white"
              style={{ alignSelf: "center" }}
            />
            <p
              className="text-white text-center poppins-semiBold"
              style={{ fontSize: "12px", color: "#0c2f53" }}
            >
              ACCESSORY
            </p>
          </Link>
        </Col>
      ) : (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center bg-white"
        >
          <Link
            style={{ textDecoration: "none", paddingTop: 3 }}
            className="d-flex flex-column justify-content-center"
            to="/accessories"
          >
            <TbDeviceAirpods
              size={"30%"}
              className="txt-green"
              style={{ alignSelf: "center" }}
            />
            <p
              className="txt-green text-center poppins-semiBold"
              style={{ fontSize: "10px" }}
            >
              ACCESSORY
            </p>
          </Link>
        </Col>
      )}

      {window.location.pathname === "/posts" ? (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#0c2f53" }}
        >
          <Link
            style={{ textDecoration: "none" }}
            className="d-flex flex-column justify-content-center"
            to="/posts"
          >
            <MdOutlinePostAdd
              size={"40%"}
              className="text-white"
              style={{ alignSelf: "center" }}
            />
            <p
              className="text-white text-center poppins-semiBold"
              style={{ fontSize: "12px", color: "#0c2f53" }}
            >
              BLOG
            </p>
          </Link>
        </Col>
      ) : (
        <Col
          xs={3}
          className="d-flex flex-column justify-content-center bg-white"
        >
          <Link
            style={{ textDecoration: "none", paddingTop: 3 }}
            className="d-flex flex-column justify-content-center"
            to="/posts"
          >
            <MdOutlinePostAdd
              size={"30%"}
              className="txt-green"
              style={{ alignSelf: "center" }}
            />
            <p
              className="txt-green text-center poppins-semiBold"
              style={{ fontSize: "10px" }}
            >
              BLOG
            </p>
          </Link>
        </Col>
      )}
    </Row>
  );
};

export default BottomTabNavigator;
